import { GET_GROUPS, GET_GROUPS_SUCCESS, GET_GROUPS_FAILURE, RESET_GROUPS } from "../constants/GetGroups";

const INIT_STATE = { groups: [], loadingGroups: false, error: null };

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_GROUPS:
      return INIT_STATE;
    case GET_GROUPS:
      return { ...state, loadingGroups: true, error: null };
    case GET_GROUPS_SUCCESS:
      return {
        ...state,
        loadingGroups: false,
        groups: Array.isArray(action?.payload?.payload) ? action.payload.payload : [],
      };
    case GET_GROUPS_FAILURE:
      return { ...state, loadingGroups: false, error: "Error getting groups" };
    default:
      return state;
  }
};
